import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "Trident Network - Fiber & Wireless Internet Service Provider",
      description:
        "Affordable fiber and wireless broadband plans starting at PHP 999/mo. Fast, reliable internet for rural and underserved communities in the Philippines.",
      ogTitle: "Trident Network - Fiber & Wireless Internet",
      ogDescription:
        "Fast, reliable fiber and wireless internet. Plans starting at PHP 999/mo."
    }
  },
  {
    path: "/hosting",
    name: "hosting",
    component: () => import("../views/Hosting.vue"),
    meta: {
      title: "Web & Email Hosting - Trident Network",
      description:
        "Affordable web hosting, WordPress hosting, and business email hosting in the Philippines. Reliable servers with 99.9% uptime guarantee.",
      ogTitle: "Web & Email Hosting - Trident Network",
      ogDescription:
        "Affordable hosting solutions for your business. Mail, shared, and WordPress hosting plans."
    }
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/FAQ.vue"),
    meta: {
      title: "FAQ - Trident Network",
      description:
        "Frequently asked questions about Trident Network internet plans, installation, billing, payments, and technical support.",
      ogTitle: "FAQ - Trident Network",
      ogDescription:
        "Find answers about our internet plans, installation, billing, and support."
    }
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
    meta: {
      title: "About Us - Trident Network",
      description:
        "Trident Network is an Internet Service Provider bringing fiber and wireless connectivity to underserved communities in the Bicol Region, Philippines.",
      ogTitle: "About Trident Network",
      ogDescription:
        "Bringing fiber and wireless internet to communities that mainstream providers have left behind."
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const meta = to.meta || {};

  document.title = meta.title || "Trident Network";

  const setMeta = (name, content) => {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  const setOg = (property, content) => {
    let el = document.querySelector(`meta[property="${property}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("property", property);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  if (meta.description) {
    setMeta("description", meta.description);
    setMeta("twitter:description", meta.description);
  }

  if (meta.ogTitle) {
    setOg("og:title", meta.ogTitle);
    setMeta("twitter:title", meta.ogTitle);
  }

  if (meta.ogDescription) {
    setOg("og:description", meta.ogDescription);
  }

  const url = "https://tridentnetwork.com.ph" + to.fullPath;
  setOg("og:url", url);
  let canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute("href", url);
  }

  next();
});

export default router;
